import { useGithubApp } from 'src/api';
import { ControlledCheckbox } from 'src/components/forms';
import { createTranslate } from 'src/intl/translate';

import { ServiceForm } from '../../../service-form.types';

import { GithubAppLinks } from './github-app-links';
import { InstallGithubApp } from './install-github-app';
import { OrganizationRepositoryBranchSelector } from './organization-repository-branch-selector';
import { OrganizationRepositorySelector } from './organization-repository-selector';
import { RepositoriesIndexing } from './repositories-indexing';

const T = createTranslate('modules.serviceForm.source.git');

export function OrganizationRepository() {
  const githubApp = useGithubApp();

  if (!githubApp) {
    return <InstallGithubApp />;
  }

  if (githubApp.indexing) {
    return (
      <>
        <RepositoriesIndexing />
        <GithubAppLinks />
      </>
    );
  }

  return (
    <>
      <OrganizationRepositorySelector />

      <OrganizationRepositoryBranchSelector />

      <ControlledCheckbox<ServiceForm, 'source.git.organizationRepository.autoDeploy'>
        name="source.git.organizationRepository.autoDeploy"
        label={<T id="autoDeploy" />}
        tooltip={<T id="autoDeployTooltip" />}
        className="self-start"
      />

      <GithubAppLinks />
    </>
  );
}
